import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SwitcherIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Switcher",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.74 9.5c0 .63.51 1.14 1.14 1.14h15.31l-4.28 4.3c-.23.21-.37.51-.37.84s.14.63.37.84a1.14 1.14 0 0 0 1.66 0s6.29-6.32 6.29-6.32c.1-.09.18-.19.25-.31.05-.13.09-.28.09-.44s-.03-.31-.09-.44c-.06-.14-.14-.27-.25-.38l-6.29-6.39a1.18 1.18 0 0 0-1.66 1.68l4.28 4.3H6.88c-.63 0-1.14.51-1.14 1.14v.05Zm20.53 13.02c0-.63-.51-1.14-1.14-1.14H9.79l4.3-4.3a1.182 1.182 0 1 0-1.67-1.67l-6.33 6.28c-.11.11-.2.24-.26.38-.05.14-.09.29-.09.44s.03.31.09.44c.06.14.15.27.26.38l6.32 6.32a1.182 1.182 0 1 0 1.67-1.67l-4.29-4.31h15.34c.63 0 1.14-.51 1.14-1.14Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 9.94H5.29a1.14 1.14 0 1 1 0-2.28h22.86a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.34 15.75c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l4.99-4.99-4.99-4.99a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l5.8 5.8c.45.45.45 1.17 0 1.62l-5.8 5.8c-.22.22-.52.33-.81.33M25.86 23.48H3a1.14 1.14 0 1 1 0-2.28h22.86a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.8 29.29c-.29 0-.58-.11-.81-.33l-5.8-5.8a1.14 1.14 0 0 1 0-1.62l5.8-5.8a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.99 4.99 4.99 4.99a1.14 1.14 0 0 1-.81 1.95"
      })]
    })
  }));
};
SwitcherIcon.displayName = 'SwitcherIcon';